import { useFormatter } from '@api/useFormatter'
import { Col, Row } from 'antd'
import React, { useMemo } from 'react'
import { useOrderContainersContext } from '../../../../Contexts/OrderContainersContext'
import { useWizardMaster } from '../../../../Contexts/WizardMasterContext'
import { PaneFooter } from '../Layout/PaneFooter'
import { CancelButton } from './Cancel'
import { NextButton } from './SaveProducts'

export const ProductPaneNavigation = () => {
  const { wizardOrder, currentEntryMode } = useWizardMaster()
  const { pocketsAllocated, containers, productGroupsApi, productMaxVolume } = useOrderContainersContext()
  const { formatVolume } = useFormatter({})

  const canSave = useMemo(() => {
    if (currentEntryMode === 'by_compartment') return pocketsAllocated
    return productGroupsApi.isVolumeValid && productGroupsApi.compartments.length > 0
  }, [currentEntryMode, pocketsAllocated, productGroupsApi.isVolumeValid, productGroupsApi.compartments])

  if (canSave)
    return <PaneFooter nextButton={NextButton} backButton={wizardOrder && CancelButton} className='success' />

  if (currentEntryMode === 'by_compartment')
    return (
      <Row className='pane-footer warning'>
        <Col span={24}>
          You will need to fill all {containers && containers.length} pockets before choosing the supply option
        </Col>
      </Row>
    )

  return (
    <Row className='pane-footer warning'>
      <Col span={24} data-cy='orderModal-destinationsProducts-footerValidationMessage'>
        {(() => {
          switch (productGroupsApi.volumeStatus) {
            case 'above':
              return `The total order volume exceeds the configured maximum of ${formatVolume(productMaxVolume)}`
            case 'below':
              return "The total order volume doesn't meet the configured minimum"
            case 'missing':
              return 'One or more allocations are missing volume'
            case 'diff_to_loaded':
              return 'One or more product volumes do not match what was originally loaded.'
            default:
              return 'You need to add at least one product to continue'
          }
        })()}
      </Col>
    </Row>
  )
}
